/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ThirdPartiesInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Information for Third Party Political Advertising in Nova Scotia"
              description={
                <>
                  <br/><h3>What do I need to know if I want to do third-party election advertising?</h3>
<p>Nova Scotia&#39;s <em>Elections Act</em> has rules for the registration, regulation and reporting of third-party advertisements.</p>

<br/><h3>What is a third party?</h3>
<p>According to the <em>Elections Act</em>, a third party is an individual or group that is not a candidate, registered political party, or registered electoral district association. A third party is not directly involved in an election. For example, a third party can be a corporation, a trade union or another group.</p>

<p>A third party must register with Elections Nova Scotia after it spends more than $500 on election advertising.</p>

<br/><h3>What is a third-party election advertisement?</h3>
<p>A third-party election advertisement is a message that promotes or opposes:</p>

<ul style={{ paddingLeft: "40px" }}>
  <li>a registered political party</li>
  <li>the election of a certain candidate, or</li>
  <li>a candidate&#39;s position on an issue.</li>
</ul>

<p>It can advertise a position on a certain political issue, such as taxes.</p>

<p>A third-party advertisement can be for radio, television, newspaper, the Internet or any other type of media. Campaign buttons, clothing, or other things that identify the users as supporters or opponents of any recognized party or candidate also can be types of third-party advertising.</p>

<br/><h3>What <em>isn&#39;t</em> a third-party election advertisement?</h3>
<p>Many communications that appear during an election are not third-party advertisements, for example:</p>

<ul style={{ paddingLeft: "40px" }}>
  <li>editorials, debates, speeches, interviews, columns, letters, commentaries and news</li>
  <li>a book, or the promotion of the sale of a book for not less than its commercial value, especially if the book was going to be promoted before the election was called</li>
  <li>a document sent by a person or a group to members, employees or shareholders, such as a newsletter</li>
  <li>a non-commercial email from an individual expressing personal political views</li>
</ul>

<br/><h3>TO REGISTER AS A THIRD PARTY</h3>

<br/><h3>What do I have to do?</h3>
<br/>
<h4>Before an election is called</h4>
<ul style={{ paddingLeft: "40px" }}>
  <li>Keep track of all contributions you receive for election advertising purposes. <u>Only individuals resident in Nova Scotia may make a contribution to a third party.</u></li>
  <li>Record the name and address of each contributor and the donation amount.</li>
  <li>Save your receipts, bills or vouchers for money spent on election advertising.</li>
</ul>
<br/>
<h4>After an election is called</h4>

<p>You must appoint a person to act as an <strong>financial agent</strong> for the third party if it spends more than $500 on election advertising.</p>

<p>The financial agent accepts contributions made to the third party for election advertising purposes. He or she must authorize every election advertising expense incurred by the third party.</p>

<p>Then, you should apply to register as a third party with Elections Nova Scotia.</p>

<p>Send your completed application (Form 7-1), within seven days of incurring $500 in expenses, to the Chief Electoral Officer, and include:</p>

<ol style={{ paddingLeft: "40px" }}>
  <li>The name, address and telephone number of:
    <ul style={{ paddingLeft: "40px" }}>
      <li>the individual, if the third party is an individual, or</li>
      <li>the corporation and the officer who has signing authority for it, if the third party is a corporation, or</li>
      <li>the group and a person who is responsible for the group, if the third party is a group, or the name, address and telephone number of the group</li>
    </ul>
    <p>NOTE: The name of the group must not be easily confused with the name of a recognized political party or election candidate.</p>
  </li>
  <li>The name and address of the officer who has signing authority for the group</li>
  <li>Where the third party is a trade union, corporation or other entity with a governing body, a copy of the resolution authorizing the group to spend money on election advertising</li>
  <li>The signature of the individual, or the signature of the group’s officer with signing authority</li>
  <li>The civic address and telephone number of the office where the individual or group’s books and records are kept, including the mailing address, if different</li>
  <li>The name, address and telephone number of the individual or group’s <strong>financial agent</strong></li>
</ol>
<br/>
<p><strong>IT&#39;S A FACT:&nbsp;</strong>The total contributions by an individual to all registered third&nbsp;parties must not exceed five thousand dollars in any calendar year.</p>
<br/>
<p><strong>When registration ends</strong></p>
<p>The registration of a third party is valid for only the election period during which the application is made. This means that a third party must register for each general or by-election. A registration for one election period will not be valid and cannot be carried forward for another election period.</p>

<br/><h3>WHAT TO REPORT AS A THIRD PARTY</h3>
<br/>
<h4>Four months after election day</h4>
<p>You or your official agent must file an election advertising report with Elections Nova Scotia, including:</p>

<ul style={{ paddingLeft: "40px" }}>
  <li>total contributions for election advertising purposes that were received up to six months before the election was called and until Election Day</li>
  <li>the name and address for each person who made contributions totalling more than $200 for election advertising purposes</li>
  <li>the amount and date of each contribution</li>
  <li>a list of the times and placements of all election advertising you paid for</li>
  <li>a list of your election advertising expenses</li>
  <li>signed declarations from your financial agent and, if different, the original applicant</li>
</ul>
<br/>
<p>NOTE: If you had no election advertising expenses, then clearly write that in your advertising report.</p>
<br/>
<p><strong>What else can Elections Nova Scotia ask me to provide?</strong></p>
<p>You might be asked for an original bill, receipt or voucher for any advertising expense greater than $50.</p>

<br/><h3>OTHER THIRD-PARTY REGULATIONS</h3>
<br/>
<p><strong>Do I have to identify the third party in my advertisements?</strong></p>
<p>Yes. A third-party election advertisement must clearly identify the name of the third party that has paid for the advertisement. For example, the ad must clearly state the name of a person, business, trade union, or other group.</p>
<br/>
<p><strong>Who can I <em>not</em> choose as financial agent?</strong></p>
<p>The <em>Elections Act</em> does not allow any of the following people to be a financial agent:</p>

<ul style={{ paddingLeft: "40px" }}>
  <li>a Member of the Legislative Assembly (MLA)</li>
  <li>an election candidate</li>
  <li>an auditor acting for a registered political party, an electoral district association, or a candidate</li>
  <li>an election officer or an employee of Elections Nova Scotia</li>
  <li>a person who does not have full capacity to enter into contracts</li>
  <li>a person who was convicted of an offence under the current or former <em>Elections Act</em> in the past seven years</li>
</ul>
<br/>
<p><strong>What if I receive an anonymous donation?</strong></p>
<p>A third party cannot use money if it does not know the name or address of the person who contributed.</p>
<br/>
<p><strong>When can I run third-party advertising?</strong></p>
<p>In general, third-party election advertising runs during an election campaign, but it can start before an election is called.</p>
<br/>
<p><strong>How much can we spend on third party advertising?</strong></p>
<p>A third party can spend no more than $2,000 (2010) on advertising that promotes or opposes the election of one or more candidates during a by-election.</p>

<p>In total, you can spend up to approximately $10,000 on advertising during a general election. See candidate and party spending limits and reimbursements for the 41st provincial general election.</p>

<p>A third party cannot subdivide or join together with another third party in order to sidestep the spending limits.</p>
<br/>
<p><strong>Why does Elections Nova Scotia monitor third-party election advertising?</strong></p>
<p>The public needs to know who is sponsoring an election advertisement and the interest that lies behind any publicly stated position.</p>
<br/>
<p><strong>Can I run third-party election advertising on election day?</strong></p>
<p>Third-party election advertising on election day was once banned, but that section of the Elections Act has been repealed. Election advertising is now allowed on election day.</p>
<br/>
<p>EXAMPLE:</p>
<p>Wanda is head of a union which is shooting television ads to promote its support for one political party. She is official agent for her union. The day after the election was called, Wanda applied to register the union as a third-party advertiser with Elections Nova Scotia. Her union cannot spend more than $10,000 to advertise its support for the party.</p>

                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ThirdPartiesInformation;
